import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _isEmpty from "lodash/isEmpty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { getBottomLine, getConsBullets, getDisplayName as getName, getProductType, getProsBullets, getSlug } from '@nerdwallet/marketplace/selectors/common';
import { PRODUCT_TYPES } from '@nerdwallet/marketplace/constants';
import { getImageData, DEFAULT_DRIVER_GROUP } from '../lib/utils';
import mapPropsAutoLoans from './auto-loans';
import mapPropsBanking from './banking';
import mapPropsEducationLoans from './education-loans';
import mapPropsInvesting from './investing';
import mapPropsMortgages from './mortgages';
import mapPropsPersonalLoans from './personal-loans';
import mapPropsSmbLoans from './small-medium-business-loans';
import mapPropsCreditCards, { DRIVER_GROUPS_CREDIT_CARDS } from './credit-cards';
export default (function (props) {
  var pros = props.pros,
      cons = props.cons,
      marketplaceEntity = props.marketplaceEntity,
      bottomLine = props.bottomLine,
      hidePrequalCta = props.hidePrequalCta,
      explicitOverrides = _objectWithoutProperties(props, ["pros", "cons", "marketplaceEntity", "bottomLine", "hidePrequalCta"]);

  var mappedProps = {};

  switch (getProductType(marketplaceEntity)) {
    case PRODUCT_TYPES.AUTO_LOANS:
      mappedProps = mapPropsAutoLoans(props);
      break;

    case PRODUCT_TYPES.BANKING:
      mappedProps = mapPropsBanking(props);
      break;

    case PRODUCT_TYPES.CREDIT_CARDS:
      mappedProps = mapPropsCreditCards(props);
      break;

    case PRODUCT_TYPES.EDUCATION_LOANS:
      mappedProps = mapPropsEducationLoans(props);
      break;

    case PRODUCT_TYPES.INVESTING:
      mappedProps = mapPropsInvesting(props);
      break;

    case PRODUCT_TYPES.MORTGAGES:
      mappedProps = mapPropsMortgages(props);
      break;

    case PRODUCT_TYPES.PERSONAL_LOANS:
      mappedProps = mapPropsPersonalLoans(props);
      break;

    case PRODUCT_TYPES.SMB_LOANS:
      mappedProps = mapPropsSmbLoans(props);
      break;

    default:
      mappedProps = {};
      break;
  }

  return _objectSpread(_objectSpread({
    bottomLine: bottomLine || getBottomLine(marketplaceEntity),
    cons: !_isEmpty(cons) ? cons : getConsBullets(marketplaceEntity),
    heading: getName(marketplaceEntity),
    imageData: getImageData(marketplaceEntity),
    marketplaceEntity: marketplaceEntity,
    marketplaceEntitySlug: getSlug(marketplaceEntity),
    pros: !_isEmpty(pros) ? pros : getProsBullets(marketplaceEntity)
  }, mappedProps), explicitOverrides);
});
export var DRIVER_GROUPS = _objectSpread(_defineProperty({}, DEFAULT_DRIVER_GROUP, DEFAULT_DRIVER_GROUP), DRIVER_GROUPS_CREDIT_CARDS);